import type {
  AiSubtitlesFeature,
  BrowserBasedStudioFeature,
  CustomVodManifestUrlFeature,
  LiveStreamingHoursFeature,
  SsoBasedUserManagementFeature,
  TermsAndConditionsFeature,
  WatermarkingFeature,
} from '../../../generated/graphql-manager';

import { useParams } from 'react-router';

import { useGetFeaturesQuery } from '../../../generated/graphql-manager';

export function useGetFeatures() {
  const { channelId = '' } = useParams();
  const { data } = useGetFeaturesQuery({ variables: { lsproId: channelId }, skip: !channelId });

  const features = data?.lsproSettings?.features || [];

  const isBrowserBasedStudioFeatureEnabled = features.find(
    (feature): feature is BrowserBasedStudioFeature => feature.__typename === 'BrowserBasedStudioFeature'
  )?.enabled;

  const isLiveStreamingHoursFeatureEnabled = features.find(
    (feature): feature is LiveStreamingHoursFeature => feature.__typename === 'LiveStreamingHoursFeature'
  )?.enabled;

  const isAiSubtitleFeatureEnabled = features.find(
    (feature): feature is AiSubtitlesFeature => feature.__typename === 'AiSubtitlesFeature'
  )?.enabled;

  const isTermsAndConditions = features.find(
    (feature): feature is TermsAndConditionsFeature => feature.__typename === 'TermsAndConditionsFeature'
  );

  const isWatermarkingFeatureEnabled = features.find(
    (feature): feature is WatermarkingFeature => feature.__typename === 'WatermarkingFeature' && feature.enabled
  );

  const isSSOBasedUserManagementFeatureEnabled = features.find(
    (feature): feature is SsoBasedUserManagementFeature => feature.__typename === 'SSOBasedUserManagementFeature'
  )?.enabled;

  const isVideoVodManifestUrlEnabled = features.find(
    (feature): feature is CustomVodManifestUrlFeature => feature.__typename === 'CustomVodManifestUrlFeature'
  )?.enabled;

  return {
    isBrowserBasedStudioFeatureEnabled,
    isLiveStreamingHoursFeatureEnabled,
    isAiSubtitleFeatureEnabled,
    isTermsAndConditions,
    isWatermarkingFeatureEnabled,
    isSSOBasedUserManagementFeatureEnabled,
    isVideoVodManifestUrlEnabled,
  };
}
